import React from "react";
import { Skeleton } from "@mui/lab";

export const TaskCardSkeleton: React.FC = () => {
    return (
        <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
            {/* Status Badge Skeleton */}
            <div className="p-4 pb-0">
                <Skeleton
                    variant="rectangular"
                    width={120}
                    height={32}
                    className="rounded-full"
                />
            </div>

            {/* Card Content */}
            <div className="p-4 space-y-3">
                {/* Task Name */}
                <div>
                    <Skeleton variant="text" width="80%" height={24} />
                    <Skeleton variant="text" width="60%" height={16} className="mt-2" />
                </div>

                {/* Assigned To */}
                <div className="flex items-center space-x-2">
                    <Skeleton variant="circular" width={20} height={20} />
                    <div className="flex-1 space-y-1">
                        <Skeleton variant="text" width={60} height={14} />
                        <Skeleton variant="text" width="70%" height={18} />
                    </div>
                </div>

                {/* Interviews Count */}
                <div className="flex items-center space-x-2">
                    <Skeleton variant="circular" width={20} height={20} />
                    <div className="flex-1 space-y-1">
                        <Skeleton variant="text" width={60} height={14} />
                        <Skeleton variant="text" width={50} height={18} />
                    </div>
                </div>

                {/* Progress Bars */}
                <div className="space-y-2 pt-2 border-t border-gray-100">
                    <div>
                        <div className="flex items-center justify-between mb-1">
                            <Skeleton variant="text" width={60} height={14} />
                            <Skeleton variant="text" width={40} height={14} />
                        </div>
                        <Skeleton variant="rectangular" width="100%" height={8} className="rounded-full" />
                    </div>
                    <div>
                        <div className="flex items-center justify-between mb-1">
                            <Skeleton variant="text" width={50} height={14} />
                            <Skeleton variant="text" width={40} height={14} />
                        </div>
                        <Skeleton variant="rectangular" width="100%" height={8} className="rounded-full" />
                    </div>
                </div>
            </div>
        </div>
    );
};

